import { MrbBaseRouteStore } from "mrb/core";

class ContentExplorerRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);
    }
}

export default ContentExplorerRouteStore;
